import { render, staticRenderFns } from "./RedisCacheConfig.vue?vue&type=template&id=7a0995c6&"
import script from "./RedisCacheConfig.vue?vue&type=script&lang=js&"
export * from "./RedisCacheConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports